import React, { useEffect } from "react";
import './skills.scss';
import icon1 from './../../image/icons/devicon_photoshop.svg';
import icon2 from './../../image/icons/devicon_webflow.svg';
import icon3 from './../../image/icons/gg_figma.svg';
import icon4 from './../../image/icons/logos_adobe-indesign.svg';
import icon5 from './../../image/icons/logos_figma.svg';
import icon6 from './../../image/icons/material-symbols_person.svg';
import icon7 from './../../image/icons/mingcute_computer-fill.svg';
import icon8 from './../../image/icons/mingcute_tool-fill.svg';
import icon9 from './../../image/icons/miro.svg';
import icon10 from './../../image/icons/ph_option.svg';
import icon11 from './../../image/icons/ph_strategy-fill.svg';
import icon12 from './../../image/icons/pixelarticons_section-plus.svg';
import icon13 from './../../image/icons/radix-icons_mobile.svg';
import icon14 from './../../image/icons/skill-icons_illustrator.svg';
import icon15 from './../../image/icons/tabler_route.svg';
import { Link } from "react-router-dom";

const Skills: React.FC = () => {
  

  return (
    <>
      <section className="skills container">
        <div className="wrapper">
          <h2>My skill/toolset</h2>
          <div className="skill-wrapper">
            <h3>UI/UX Design and Graphic tools:</h3>
            <div className="skills-container">
              <div className="skill">
                <img src={icon5} alt="" />
                <span>Figma</span>
              </div>
              <div className="skill">
                <img src={icon1} alt="" />
                <span>Photoshop</span>
              </div>
              <div className="skill">
                <img src={icon14} alt="" />
                <span>Illustrator</span>
              </div>
              <div className="skill">
                <img src={icon4} alt="" />
                <span>InDesign</span>
              </div>
              <div className="skill">
                <img src={icon9} alt="" />
                <span>Miro</span>
              </div>
              <div className="skill">
                <img src={icon2} alt="" />
                <span>Webflow</span>
              </div>
            </div>
          </div>
          <div className="skill-wrapper">
            <h3>UX Frameworks & Skills:</h3>
            <div className="skills-container">
              <div className="skill">
                <img src={icon8} alt="" />
                <span>Design thinking approach</span>
              </div>
              <div className="skill">
                <img src={icon6} alt="" />
                <span>Usability testing</span>
              </div>
              <div className="skill">
                <img src={icon7} alt="" />
                <span>Web Design</span>
              </div>
              <div className="skill">
                <img src={icon13} alt="" />
                <span>Mobile App Design</span>
              </div>
              <div className="skill">
                <img src={icon15} alt="" />
                <span>Customer Journey Map</span>
              </div>
              <div className="skill">
                <img src={icon10} alt="" />
                <span>User Flow</span>
              </div>
              <div className="skill">
                <img src={icon12} alt="" />
                <span>Design System</span>
              </div>
              <div className="skill">
                <img src={icon3} alt="" />
                <span>Prototyping</span>
              </div>
              <div className="skill">
                <img src={icon11} alt="" />
                <span>UX Strategy</span>
              </div>
              <div className="skill">
                <img src={icon6} alt="" />
                <span>Accessibility</span>
              </div>
            </div>
          </div>
          <div className="skill-wrapper">
            <h3>Additional skills</h3>
            <div className="skills-container">
              <div className="skill">
                <img src={icon8} alt="" />
                <span>HTML / CSS</span>
              </div>
              <div className="skill">
                <img src={icon6} alt="" />
                <span>JavaScript</span>
              </div>
              <div className="skill">
                <img src={icon13} alt="" />
                <span>Swift / SwiftUI</span>
              </div>
              <div className="skill">
                <img src={icon7} alt="" />
                <span>Flutter</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      
    </>
  );
};

export default Skills;
